import { RouteLocationNormalizedLoaded, createRouter, createWebHashHistory } from 'vue-router'
import Keys from './Keys.vue'
import KeyDetails from './KeyDetails.vue'

const routes = [
    { name:'Keys', path: '/', component: Keys},
    { name:'KeyDetails',path: '/Key/:id', component: KeyDetails, props:(route:RouteLocationNormalizedLoaded)=> ({ id: +route.params.id })},
    { name:'NewKey',path: '/Key', component: KeyDetails, props:true}

 ];

export function getRouter()
{
    return createRouter({
        history: createWebHashHistory(),
        routes:  routes
        });
}